<template>
  <div class="main">
    <van-overlay :show="show" @click="show = true">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="header">{{title}}</div>
          <div class="contentText">{{content}}</div>
          <div class="footer">
            <div @click="hideDialog">知道了</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                default: '标题'
            },
            show: {
                type: Boolean,
                default: false
            },
            content: {
                type: String,
                default: '内容'
            }
        },
        data () {
            return {
            };
        },
        methods: {
            hideDialog () {
                this.$emit('hideDialog');
            }
        }
    };
</script>
<style lang="less" scoped>
.main {
  .van-overlay {
    background-color: rgba(0,0,0,.3);
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 260px;
    height: 188px;
    background-color: #fff;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header {
      font-size: 16px;
      color: #000000;
      padding: 37px 16px 0px;
      font-weight: bold;
      line-height: 24px;
    }
    .contentText {
      color: #666666;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      line-height:18px;
      padding:  19px 16px 24px;
    }
    .footer {
      width:228px;
      height:38px;
      background:rgba(54,179,116,1);
      border-radius:2px;
      border:1px solid rgba(54,179,116,1);
      div {
        color: #fff;
        font-size: 14px;
        height: 40px;
        border-radius: 5px;
        text-align: center;
        line-height: 38px;
      }
    }
  }
}
</style>
